import { createSlice } from '@reduxjs/toolkit'

type domainDetail = {
  storageLocation: string[]
  domainDivisionRegionId: string[]
  domain: string
  division: string[]
}

type domainDivisionDetail = {
  storageLocation: string
  domainDivisionRegionId: number | string
  domain: string
  division: string
}

type InitialState = {
  domainList: domainDetail[]
  currentDomain: domainDetail
  divisionDomain: domainDivisionDetail
}

const initialState: InitialState = {
  domainList: [],
  currentDomain: {
    storageLocation: [],
    domainDivisionRegionId: [],
    domain: '',
    division: [],
  },
  divisionDomain: {
    storageLocation: '',
    domainDivisionRegionId: 0,
    domain: '',
    division: '',
  },
}

export const domainSlice = createSlice({
  name: 'domain',
  initialState,
  reducers: {
    setDomainList: (state, action) => {
      const { domains } = action.payload
      state.domainList = domains
    },
    setCurrentDomain: (state, action) => {
      const { currentDomain } = action.payload
      state.currentDomain = currentDomain
    },
    setDivisionDomain: (state, action) => {
      const { divisionDomain } = action.payload
      state.divisionDomain = divisionDomain
    },
  },
})

// Action creators are generated for each case reducer function
export const { setDomainList, setCurrentDomain, setDivisionDomain } =
  domainSlice.actions

export default domainSlice.reducer
